import { memo } from "react";
import { useTranslation } from "react-i18next";
import { protocolColumns } from "../../Constants/protocolColumns";
import { toDateTime } from "../../Services/string.service";
import EmptyData from "../../components/EmptyData";

const DATE_FIELDS = ["eventDate", "reminderDate", "lastUpdate"];

function ProtocolGrid({ gridData, onViewDetails }) {
  const { t } = useTranslation();
  const columns = protocolColumns(t);

  const renderCell = (field, value) => {
    if (DATE_FIELDS.includes(field)) {
      return value ? toDateTime(value) : "";
    }

    return value ?? "";
  };

  if (!Array.isArray(gridData) || gridData.length === 0) {
    return <EmptyData />;
  }

  return (
    <div className="card">
      <div className="table-responsive text-nowrap">
        <table className="table table-grid" id="protocol-grid">
          <thead>
            <tr>
              <th></th>
              {columns.map(({ field, header }) => (
                <th key={field}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className="table-border-bottom-0">
            {gridData.map((item, index) => (
              <tr key={item.protocolId ?? index}>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => onViewDetails(item)}
                  >
                    {t("PROTOCOLS.DETAILS_BUTTON")}
                  </button>
                </td>
                {columns.map(({ field }) => (
                  <td key={field}>{renderCell(field, item[field])}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default memo(ProtocolGrid);
